import {
  Plugin,
  MediaEmbedEditing,
  MediaEmbedUI,
  Collection,
  createDropdown,
  addListToDropdown,
} from 'ckeditor5'
import ContainerMediaGalery from 'src/container/video-gallery'
import Embed from '../../embed'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import { track } from '@amplitude/analytics-browser'
import ComponentBoxContent from 'src/model/component-box'

const checkIfInsideSimpleBox = (selection, editor) => {
  const position = selection.getFirstPosition()
  if (!position) return false

  // Get all ancestors of the current position
  const ancestors = position.getAncestors()

  // Check if any ancestor is a simple box
  return ancestors.some(ancestor => {
    // Check if the element is a section with simple-box class
    if (ancestor.name === 'simpleBox') {
      const classes = editor.model.schema.getAttributeProperties(
        ancestor,
        'class',
      )
      return classes
    }
    return false
  })
}

const handleAddVideo = (dispatch, editor) => {
  track('media_gallery_in_editor_clicked')

  /**
   *
   * @param {} items
   */
  const onOk = item => {
    const itemUrl = item[0].link
    const shopClipId = item[0].id || ''
    const shopClipAttr = shopClipId ? ` data-shop-clip-id="${shopClipId}"` : ''

    if (editor) {
      const model = editor.model
      const selection = model.document.selection
      var sampleHtml

      const isInsideSimpleBox = checkIfInsideSimpleBox(selection, editor)
      if (isInsideSimpleBox === true) {
        sampleHtml = `<div class="video-wrapper"><video class="video-player" aspectratio="16/9" src="${itemUrl}"${shopClipAttr}/></div>`
      } else {
        sampleHtml = `
          <div class="simple-box-wrapper">
            <div class="simple-box">
              <div class="column">
                <div class="video-wrapper"><video class="video-player" aspectratio="16/9" src="${itemUrl}"${shopClipAttr}/></div>
              </div>
            </div>
          </div>`
      }

      const viewFragment = editor.data.processor.toView(sampleHtml)
      const modelFragment = editor.data.toModel(viewFragment)
      editor.model.insertContent(modelFragment)
    }

    dispatch(messageBoxHideAction())
  }
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        buttons: [],
        title: `
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
         
          <Icon
            icon="ic:round-add-a-photo"
            color="#00AB55"
            width="24"
            height="24"
          />
          <Typography
            style="
              margin-left: 8;
              color: #002E47;
              fontWeight: 600;
              fontSize: 16;
            "
          >
            Media Gallery
          </Typography>
        </div>`,
        variant: MessageBoxVariant.DRAGGABLE,
        component: <ContainerMediaGalery onOk={onOk} />,
        maxHeight: '640px',
      }),
    ),
  )
}

const handleAddMedia = (dispatch, editor, modalData) => {
  const selection = editor.model.document.selection

  const onOk = item => {
    const itemUrl = item

    if (editor) {
      const model = editor.model
      const selection = model.document.selection
      const isInsideSimpleBox = checkIfInsideSimpleBox(selection, editor)
      if (isInsideSimpleBox === true) {
        editor.model.change(writer => {
          const videoWrapper = writer.createElement('videoWrapper')

          const figure = writer.createElement('media', {
            url: itemUrl,
          })
          writer.append(figure, videoWrapper)

          editor.model.insertContent(videoWrapper, selection.getFirstPosition())
        })
      } else {
        editor.model.change(writer => {
          const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
          const simpleBox = writer.createElement('simpleBox')
          const videoWrapper = writer.createElement('videoWrapper')
          const column = writer.createElement('column')

          const figure = writer.createElement('media', {
            url: itemUrl,
          })

          writer.append(simpleBox, simpleBoxWrapper)
          writer.append(column, simpleBox)
          writer.append(videoWrapper, column)
          writer.append(figure, videoWrapper)

          editor.model.insertContent(
            simpleBoxWrapper,
            selection.getFirstPosition(),
          )
        })
      }
    }

    dispatch(messageBoxHideAction())
  }

  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: ``,
        buttons: [],
        component: (
          <Embed
            modalData={modalData}
            onEmbed={url => {
              onOk(url, selection, modalData, editor)
              dispatch(messageBoxHideAction())
            }}
          />
        ),
        callback: () => {
          editor.execute('undo')
        },
      }),
    ),
  )
}

class CustomVideo extends Plugin {
  constructor(editor) {
    super(editor)
    this.dispatch = editor.config.get('videoGalleryPlugin.dispatch')
  }

  static get requires() {
    return [MediaEmbedEditing, MediaEmbedUI]
  }

  static get pluginName() {
    return 'CustomVideo'
  }

  init() {
    const editor = this.editor
    const t = editor.t

    editor.config.set('mediaEmbed', {
      previewsInData: true,
    })

    editor.ui.componentFactory.add('customVideo', locale => {
      const items = new Collection()

      const videoList = [
        {
          value: '',
          label: '',
          prompt: '',
        },
        {
          value: 'uploadFromComputer',
          label: 'Upload from computer',
          prompt: '',
          svg: `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.20866 4.66699C3.94301 4.66699 2.91699 5.69301 2.91699 6.95866V10.9532C2.45887 11.1634 2.038 11.4409 1.66699 11.7729V6.95866C1.66699 5.00265 3.25265 3.41699 5.20866 3.41699H14.792C16.748 3.41699 18.3337 5.00265 18.3337 6.95866V14.042C18.3337 15.998 16.748 17.5837 14.792 17.5837H9.54648C9.72644 17.1916 9.85719 16.7723 9.93081 16.3337H14.792C16.0576 16.3337 17.0837 15.3076 17.0837 14.042V6.95866C17.0837 5.69301 16.0576 4.66699 14.792 4.66699H5.20866Z" fill="#002E47"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 18.5C6.65685 18.5 8 17.1569 8 15.5C8 13.8431 6.65685 12.5 5 12.5C3.34315 12.5 2 13.8431 2 15.5C2 17.1569 3.34315 18.5 5 18.5ZM5 19.5C7.20914 19.5 9 17.7091 9 15.5C9 13.2909 7.20914 11.5 5 11.5C2.79086 11.5 1 13.2909 1 15.5C1 17.7091 2.79086 19.5 5 19.5Z" fill="#002E47"/>
                <path d="M5.28284 13.6172C5.35786 13.6922 5.4 13.7939 5.4 13.9V15.1H6.6C6.70609 15.1 6.80783 15.1421 6.88284 15.2172C6.95786 15.2922 7 15.3939 7 15.5C7 15.6061 6.95786 15.7078 6.88284 15.7828C6.80783 15.8579 6.70609 15.9 6.6 15.9H5.4V17.1C5.4 17.2061 5.35786 17.3078 5.28284 17.3828C5.20783 17.4579 5.10609 17.5 5 17.5C4.89391 17.5 4.79217 17.4579 4.71716 17.3828C4.64214 17.3078 4.6 17.2061 4.6 17.1V15.9H3.4C3.29391 15.9 3.19217 15.8579 3.11716 15.7828C3.04214 15.7078 3 15.6061 3 15.5C3 15.3939 3.04214 15.2922 3.11716 15.2172C3.19217 15.1421 3.29391 15.1 3.4 15.1H4.6V13.9C4.6 13.7939 4.64214 13.6922 4.71716 13.6172C4.79217 13.5421 4.89391 13.5 5 13.5C5.10609 13.5 5.20783 13.5421 5.28284 13.6172Z" fill="#002E47"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3516 7.23568L10.3318 7.22429C9.95466 7.00735 9.63474 6.82333 9.36823 6.70106C9.09999 6.57799 8.79301 6.47176 8.46003 6.50677C8.0013 6.55534 7.58248 6.79653 7.31127 7.17175C7.11448 7.4431 7.05372 7.76173 7.02669 8.05552C6.99998 8.34592 6.99999 8.71271 7 9.14463V9.14466V10.8086C7.45087 10.9753 7.87113 11.2051 8.25006 11.4873C8.25001 11.4354 8.25 11.3813 8.25 11.325V9.17412C8.25 8.70469 8.25063 8.39616 8.27144 8.17003C8.29121 7.9551 8.3232 7.90557 8.3232 7.90557L8.32422 7.90416C8.38618 7.81835 8.48339 7.76156 8.59067 7.74992C8.59488 7.74983 8.65735 7.75019 8.84698 7.83719C9.05351 7.93195 9.32168 8.0853 9.72838 8.31923L11.5988 9.39528C12.0078 9.63019 12.2768 9.78537 12.4637 9.91687C12.6406 10.0413 12.6684 10.0946 12.6684 10.0946L12.6691 10.0962C12.6908 10.1446 12.7021 10.197 12.7021 10.25C12.7021 10.303 12.6908 10.3554 12.6691 10.4037L12.6683 10.4055C12.6662 10.4092 12.6342 10.4632 12.4636 10.5833C12.2765 10.7149 12.0075 10.8703 11.5983 11.1057L9.72838 12.1807C9.53637 12.2911 9.37526 12.3836 9.23693 12.4604C9.48983 12.7903 9.70255 13.1525 9.86779 13.5399C10.0117 13.4598 10.1662 13.3709 10.3318 13.2756L10.3516 13.2642L12.2513 12.1722C12.6259 11.9566 12.9443 11.7735 13.1831 11.6054C13.425 11.4351 13.6727 11.2226 13.8098 10.915C13.9036 10.7058 13.9521 10.4792 13.9521 10.25C13.9521 10.0207 13.9036 9.79407 13.8098 9.58491C13.6727 9.27732 13.425 9.06477 13.1829 8.8945C12.9433 8.72593 12.6236 8.54236 12.2474 8.32631L12.2474 8.3263L10.3516 7.23568ZM13.8098 9.58491C13.8096 9.58451 13.8094 9.58411 13.8092 9.58371L13.2392 9.83995L13.8103 9.58612C13.8101 9.58572 13.8099 9.58532 13.8098 9.58491ZM13.8098 10.915L13.8103 10.9138L13.2392 10.66L13.8092 10.9162L13.8098 10.915Z" fill="#002E47"/>
                </svg>`,
        },
        {
          value: 'insertViaUrl',
          label: 'Insert via URL',
          prompt: '',
          svg: `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.20866 4.66699C3.94301 4.66699 2.91699 5.69301 2.91699 6.95866V10.6483C2.46242 10.7759 2.04059 10.9818 1.66699 11.2505V6.95866C1.66699 5.00265 3.25265 3.41699 5.20866 3.41699H14.792C16.748 3.41699 18.3337 5.00265 18.3337 6.95866V14.042C18.3337 15.998 16.748 17.5837 14.792 17.5837H11.5479C11.9625 17.2407 12.3068 16.8158 12.5559 16.3337H14.792C16.0576 16.3337 17.0837 15.3076 17.0837 14.042V6.95866C17.0837 5.69301 16.0576 4.66699 14.792 4.66699H5.20866Z" fill="#002E47"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3516 7.23568L10.3318 7.22429C9.95466 7.00735 9.63474 6.82333 9.36823 6.70106C9.09999 6.57799 8.79301 6.47176 8.46003 6.50677C8.0013 6.55534 7.58248 6.79653 7.31127 7.17175C7.11448 7.4431 7.05372 7.76173 7.02669 8.05552C6.99998 8.34592 6.99999 8.71271 7 9.14463V9.14466V10.25H8.25V9.17412C8.25 8.70469 8.25063 8.39616 8.27144 8.17003C8.29121 7.9551 8.3232 7.90557 8.3232 7.90557L8.32422 7.90416C8.38618 7.81835 8.48339 7.76156 8.59067 7.74992C8.59488 7.74983 8.65735 7.75019 8.84698 7.83719C9.05351 7.93195 9.32168 8.0853 9.72838 8.31923L11.5988 9.39528C12.0078 9.63019 12.2768 9.78537 12.4637 9.91687C12.6406 10.0413 12.6684 10.0946 12.6684 10.0946L12.6691 10.0962C12.6908 10.1446 12.7021 10.197 12.7021 10.25C12.7021 10.303 12.6908 10.3554 12.6691 10.4037L12.6683 10.4055C12.6662 10.4092 12.6342 10.4632 12.4636 10.5833C12.2891 10.7061 12.0434 10.8495 11.6792 11.0592C12.0228 11.3194 12.323 11.6338 12.5672 11.9897C12.8066 11.85 13.0147 11.724 13.1831 11.6054C13.425 11.4351 13.6727 11.2226 13.8098 10.915C13.9036 10.7058 13.9521 10.4792 13.9521 10.25C13.9521 10.0207 13.9036 9.79407 13.8098 9.58491C13.6727 9.27732 13.425 9.06477 13.1829 8.8945C12.9433 8.72593 12.6236 8.54236 12.2474 8.32631L12.2474 8.3263L10.3516 7.23568ZM13.8098 9.58491C13.8096 9.58451 13.8094 9.58411 13.8092 9.58371L13.2392 9.83995L13.8103 9.58612C13.8101 9.58572 13.8099 9.58532 13.8098 9.58491ZM13.8098 10.915L13.8103 10.9138L13.2392 10.66L13.8092 10.9162L13.8098 10.915Z" fill="#002E47"/>
        <path d="M2.82685 13.2272C3.18389 12.8896 3.66815 12.7 4.17308 12.7H4.59615C4.76446 12.7 4.92588 12.6368 5.04489 12.5243C5.16391 12.4117 5.23077 12.2591 5.23077 12.1C5.23077 11.9409 5.16391 11.7883 5.04489 11.6757C4.92588 11.5632 4.76446 11.5 4.59615 11.5H4.17308C3.33152 11.5 2.52444 11.8161 1.92937 12.3787C1.33431 12.9413 1 13.7044 1 14.5C1 15.2956 1.33431 16.0587 1.92937 16.6213C2.52444 17.1839 3.33152 17.5 4.17308 17.5H4.59615C4.76446 17.5 4.92588 17.4368 5.04489 17.3243C5.16391 17.2117 5.23077 17.0591 5.23077 16.9C5.23077 16.7409 5.16391 16.5883 5.04489 16.4757C4.92588 16.3632 4.76446 16.3 4.59615 16.3H4.17308C3.66815 16.3 3.18389 16.1104 2.82685 15.7728C2.46981 15.4352 2.26923 14.9774 2.26923 14.5C2.26923 14.0226 2.46981 13.5648 2.82685 13.2272Z" fill="#002E47"/>
        <path d="M3.72434 14.0757C3.60532 14.1883 3.53846 14.3409 3.53846 14.5C3.53846 14.6591 3.60532 14.8117 3.72434 14.9243C3.84335 15.0368 4.00477 15.1 4.17308 15.1H8.82692C8.99523 15.1 9.15665 15.0368 9.27566 14.9243C9.39468 14.8117 9.46154 14.6591 9.46154 14.5C9.46154 14.3409 9.39468 14.1883 9.27566 14.0757C9.15665 13.9632 8.99523 13.9 8.82692 13.9H4.17308C4.00477 13.9 3.84335 13.9632 3.72434 14.0757Z" fill="#002E47"/>
        <path d="M10.1731 15.7728C9.8161 16.1104 9.33185 16.3 8.82692 16.3H8.40385C8.23554 16.3 8.07412 16.3632 7.95511 16.4757C7.83609 16.5883 7.76923 16.7409 7.76923 16.9C7.76923 17.0591 7.83609 17.2117 7.95511 17.3243C8.07412 17.4368 8.23554 17.5 8.40385 17.5H8.82692C9.66848 17.5 10.4756 17.1839 11.0706 16.6213C11.6657 16.0587 12 15.2956 12 14.5C12 13.7044 11.6657 12.9413 11.0706 12.3787C10.4756 11.8161 9.66848 11.5 8.82692 11.5H8.40385C8.23554 11.5 8.07412 11.5632 7.95511 11.6757C7.83609 11.7883 7.76923 11.9409 7.76923 12.1C7.76923 12.2591 7.83609 12.4117 7.95511 12.5243C8.07412 12.6368 8.23554 12.7 8.40385 12.7H8.82692C9.33185 12.7 9.8161 12.8896 10.1731 13.2272C10.5302 13.5648 10.7308 14.0226 10.7308 14.5C10.7308 14.9774 10.5302 15.4352 10.1731 15.7728Z" fill="#002E47"/>
        </svg>`,
        },
      ]

      // Add two items to the dropdown
      videoList.forEach(item => {
        return items.add({
          type: 'button',
          model: {
            icon: item.svg,
            withText: true,
            label: item.label,
            prompt: item.prompt,
            value: item.value,
          },
        })
      })

      const dropdown = createDropdown(locale)
      addListToDropdown(dropdown, items)

      const videoIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.20866 2.16699C2.94301 2.16699 1.91699 3.19301 1.91699 4.45866V11.542C1.91699 12.8076 2.94301 13.8337 4.20866 13.8337H13.792C15.0576 13.8337 16.0837 12.8076 16.0837 11.542V4.45866C16.0837 3.19301 15.0576 2.16699 13.792 2.16699H4.20866ZM0.666992 4.45866C0.666992 2.50265 2.25265 0.916992 4.20866 0.916992H13.792C15.748 0.916992 17.3337 2.50265 17.3337 4.45866V11.542C17.3337 13.498 15.748 15.0837 13.792 15.0837H4.20866C2.25265 15.0837 0.666992 13.498 0.666992 11.542V4.45866Z" fill="#002E47"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.33182 4.97429L9.35162 4.98568L11.2474 6.0763C11.6236 6.29236 11.9433 6.47593 12.1829 6.6445C12.4253 6.81499 12.6733 7.02787 12.8103 7.33612L12.2392 7.58995L12.8092 7.33371C12.9034 7.5432 12.9521 7.77027 12.9521 7.99996C12.9521 8.2292 12.9036 8.45585 12.8098 8.665L12.8092 8.66621L12.2392 8.40997L12.8103 8.66379L12.8098 8.665C12.6727 8.97257 12.425 9.18511 12.1831 9.3554C11.9443 9.52348 11.6259 9.70664 11.2513 9.92217L9.35162 11.0142L9.33179 11.0256C8.95466 11.2426 8.6347 11.4266 8.36803 11.5489C8.09943 11.6721 7.79291 11.7781 7.45982 11.7432C6.99991 11.6945 6.58204 11.4525 6.31081 11.0787C6.11453 10.8073 6.05347 10.4879 6.02656 10.194C5.99998 9.90365 5.99999 9.53676 6 9.10433V6.89466C5.99999 6.46273 5.99998 6.09593 6.02669 5.80552C6.05372 5.51173 6.11448 5.1931 6.31127 4.92175C6.58248 4.54653 7.0013 4.30534 7.46003 4.25677C7.793 4.22176 8.09999 4.32799 8.36823 4.45106C8.63474 4.57333 8.95466 4.75735 9.33182 4.97429ZM7.59067 5.49992C7.48339 5.51156 7.38618 5.56835 7.32422 5.65416L7.3232 5.65557C7.3232 5.65557 7.29121 5.7051 7.27144 5.92003C7.25063 6.14616 7.25 6.45469 7.25 6.92412V9.07496C7.25 9.54476 7.25063 9.85365 7.27136 10.0801C7.29033 10.2873 7.321 10.3418 7.32336 10.3457C7.38694 10.4327 7.48389 10.4885 7.58979 10.5C7.59397 10.5001 7.6564 10.5001 7.84697 10.4127C8.05356 10.3179 8.32164 10.1646 8.72838 9.93069L10.5983 8.85572C11.0075 8.62032 11.2765 8.46494 11.4636 8.33326C11.6342 8.21317 11.6662 8.15923 11.6683 8.15549L11.6691 8.15371C11.6908 8.10536 11.7021 8.05296 11.7021 7.99996C11.7021 7.94695 11.6908 7.89455 11.6691 7.84621L11.6684 7.84464C11.6684 7.84464 11.6406 7.79127 11.4637 7.66687C11.2768 7.53537 11.0078 7.38019 10.5988 7.14528L8.72838 6.06923C8.32168 5.8353 8.05351 5.68195 7.84698 5.58719C7.65735 5.50019 7.59488 5.49983 7.59067 5.49992Z" fill="#002E47"/>
                </svg>`

      dropdown.buttonView.set({
        label: t('Insert video'),
        icon: videoIcon,
        tooltip: true,
      })

      // Add click handlers for the dropdown items
      dropdown.on('execute', evt => {
        const selectedItem = evt.source.value

        if (selectedItem === 'uploadFromComputer') {
          handleAddVideo(this.dispatch, editor)
        } else if (selectedItem === 'insertViaUrl') {
          const modalData = {
            name: 'Insert video via URL',
            value: 'insertViaUrl',
            image: '',
            modalImg: '/assets/editor-file/embed/video-insert-via-com.png',
            html: '&nbsp;',
            message: 'Paste YouTube or Vimeo link.',
            url: '',
          }
          handleAddMedia(this.dispatch, editor, modalData)
        }
      })

      return dropdown
    })
  }
}

export default CustomVideo
